import { render, staticRenderFns } from "./DynamicImportComponent.vue?vue&type=template&id=67ff8fae&"
import script from "./DynamicImportComponent.vue?vue&type=script&lang=js&"
export * from "./DynamicImportComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports